import { AxiosPromise } from 'axios';
import { httpClient } from '@/http';
import { Stage } from '@flow/shared/src/models/Stage';

class Apis {
  private apiEndpoint: string = process.env.VUE_APP_BASE_URL as string;
  private cdnURL: string = process.env.VUE_APP_CDN_URL as string;

  public getStageInfo(id: string, version?: string): AxiosPromise<Stage> {
    return httpClient.get(`${this.apiEndpoint}/flows/stages/${id}`, {
      params: {
        v: version,
      },
    });
  }

  public getTourInfo(id: string): AxiosPromise<any> {
    // return httpClient.get(`https://cdn.zipview.kr/flow/tour/${id}/latest.json`);
    return httpClient.get(
      `${this.cdnURL}/backstage/tours/${id}/json/latest.json`,
    );
  }
}

export default new Apis();
